import { Col, DatePicker, Form, Row, Select, Radio, Space } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import React, { useEffect, useState } from 'react';
import * as Api from 'api';
import { ThemeProvider, Button } from '@mui/material';
import outerTheme from 'theme/mui';
import { TimeClock } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import PlayArrow from '@mui/icons-material/PlayArrow';
import Stop from '@mui/icons-material/Stop';
import moment, { Moment } from 'moment';
import useAuth from 'redux/auth/auth.hook';
import classes from './style.module.scss';

type RangeValue = [Moment | null, Moment | null] | null;
const { Option, OptGroup } = Select;
const { RangePicker } = DatePicker;

const FilterMovementMap = (props) => {
  const [form] = Form.useForm();
  const { auth: { profile } } = useAuth();
  const { md } = useBreakpoint();
  const [filterOptions, setFilterOption] = useState({
    category: 'all',
    tag: '',
    dateStart: moment().format('YYYY-MM-DD'),
    dateEnd: moment().format('YYYY-MM-DD'),
  });

  const [dates, setDates] = useState<RangeValue>(null);

  const categoryArr = [
    { value: 'all', name: 'All' },
    { value: 'deer', name: 'Deer' },
    { value: 'hog', name: 'Hog' },
    { value: 'turkey', name: 'Turkey' },
    { value: 'people', name: 'People' },
    { value: 'vehicle', name: 'Vehicle' },
    { value: 'predator', name: 'Predator' },
    { value: 'other', name: 'Other' },
  ];

  const [tagArr, setTagArr] = useState<any[]>([]);
  const [dateValue, setDateValue] = useState<RangeValue>([moment(filterOptions.dateStart), moment(filterOptions.dateEnd)]);

  useEffect(() => {
    if (profile) {
      // get tags
      Api.IMAGE_ALL_TAGS({ user_id: profile.user_id }).then(((res: any) => {
        const tags = JSON.parse(res.text);
        setTagArr(tags);
        props.handleFilters(filterOptions);
        form.setFieldsValue(filterOptions);
      })).catch((error: any) => {
        console.log('error ===>', error);
      });
    }
  }, [profile]);

  const onValuesChange = (values, allvalues) => {
    const newFilter = { ...filterOptions, ...allvalues };
    setFilterOption(newFilter);
    props.handleFilters(newFilter);
  };

  const onChangeDate = (rangeValue) => {
    setDateValue(rangeValue);

    const newFilter = { ...filterOptions, dateStart: rangeValue[0].format('YYYY-MM-DD'), dateEnd: rangeValue[1].format('YYYY-MM-DD') };
    setFilterOption(newFilter);
    props.handleFilters(newFilter);
  };

  const disabledDate = (current: Moment) => {
    if (!dates) {
      return false;
    }
    if (current.diff(moment().format('YYYY-MM-DD'), 'days') > 0) {
      return true;
    }
    const tooLate = dates[0] && current.diff(dates[0], 'days') >= 7;
    const tooEarly = dates[1] && dates[1].diff(current, 'days') >= 7;
    return !!tooEarly || !!tooLate;
  };

  const onOpenChange = (open: boolean) => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };

  return (
    <div className={classes.wrapper}>
      <Form form={form} style={{ marginTop: md ? 20 : 0 }} onValuesChange={onValuesChange}>
        <div className={classes.formInputLabel}>Choose Tag:</div>
        <Form.Item name="tag" className={classes.formInputWrapper}>
          <Select size="large">
            <Option key={0} value="">All</Option> :
            {tagArr.map((val: any) => (
              val.tag != '' && (<Option key={val.tag} value={val.tag}>{val.tag}</Option>)
            ))}
          </Select>
        </Form.Item>
        <div className={classes.formInputLabel}>Choose Category:</div>
        <Form.Item name="category" className={classes.formInputWrapper}>
          <Select size="large">
            {categoryArr.map((val: any) => (
              <Option key={val.value} value={val.value}>{val.name}</Option>
            ))}
          </Select>
        </Form.Item>
        <div className={classes.formInputLabel}>Date :</div>
        <RangePicker
          style={{ width: '100%' }}
          format="YYYY-MM-DD"
          value={dates || dateValue}
          disabledDate={disabledDate}
          onCalendarChange={(val) => setDates(val)}
          onChange={(val) => onChangeDate(val)}
          onOpenChange={onOpenChange}
          onBlur={() => console.log('blur has been triggered')}
        />
      </Form>
    </div>
  );
};

export default FilterMovementMap;
